import React from 'react';

import { message } from 'antd';
import cn from 'classnames';
import { inject, observer } from 'mobx-react'
import Router from 'next/router';

import { TRADE_PATHS } from '@constants/index';
import { useOfflineSymbols, useValidCoinCode } from '@lib/hooks'
import { formatPrettyValue, I18n } from '@utils/index';

import styles from './index.module.css';

const T = (props) => {
  const { itemData, type, marketStore } = props;
  const { isOfflineSymbols } = useOfflineSymbols();
  const { isValidCoinCode } = useValidCoinCode({ marketStore })
  const data = itemData.summary || itemData.text;
  const tradingInfo = JSON.parse(data);
  const buy = tradingInfo && tradingInfo.side && tradingInfo.side === 'buy';
  const { averageTradePrice, quoteCurrency, baseCurrency } = tradingInfo;
  const coinCode = tradingInfo.baseCurrency.toUpperCase() + '_' + tradingInfo.quoteCurrency.toUpperCase();
  const tradingInfoOrderViewStyle = cn(styles.tradingInfoOrderView, 'DINPro', {
    [styles.greenBgc]: buy,
    [styles.redBgc]: !buy
  });

  const containerStyle = cn(styles.container, {
    [styles.mt24]: type === 'feed'
  });

  const handleClick = () => {
    if (type === 'detail') {
      if (isOfflineSymbols(coinCode)) {
        message.warning(I18n.t('symbol_offline_tip'))
        return;
      }
      if (!isValidCoinCode(coinCode)) {
        return;
      }
      Router.push(`${TRADE_PATHS.TRADE}/${coinCode}`)
    }
  }

  return (
    <div className={containerStyle} onClick={handleClick}>
      {
        I18n.locale === 'en'
          ? (
            <span className={tradingInfoOrderViewStyle}>
              {I18n.t('social_buy_sell')}
              <span className={cn(styles.tradingInfoOrderBoldText, 'DINPro-Medium')}>
                {buy ? I18n.t('social_buy') : I18n.t('social_sell')} ${baseCurrency}
              </span>
              {I18n.t('social_trade_info', {
                quoteCurrency: quoteCurrency,
                averageTradePrice: formatPrettyValue(averageTradePrice)
              })}
            </span>
            )
          : (
            <span className={tradingInfoOrderViewStyle}>
              {I18n.t('social_trade_info', {
                averageTradePrice: formatPrettyValue(averageTradePrice),
                quoteCurrency: quoteCurrency
              })}
              <span className={cn(styles.tradingInfoOrderBoldText, 'DINPro-Medium')}>
                {buy ? I18n.t('social_buy') : I18n.t('social_sell')}${baseCurrency}
              </span>
            </span>
            )
      }
    </div>
  )
}

export default inject(rootStore => {
  return {
    marketStore: rootStore.store.marketStore
  }
})(observer(T))
